export const APP_API_URL = process.env.GATSBY_API_URL
export const ESIA_API_URL = process.env.GATSBY_APP_ESIA_API_URL
export const APP_API_HOST = process.env.GATSBY_APP_API_HOST || "https://api-app.sovcombank.ru"
